<template>
  <TransitionRoot appear :show="!modalHidden" as="template">
    <Dialog as="div" @close="closeModal" @keypress="keypress">
      <div class="fixed inset-0 z-10 overflow-y-auto">
        <div class="min-h-screen px-1 sm:px-4 text-center">
          <TransitionChild
            as="template"
            enter="duration-100 ease-out"
            enter-from="opacity-0"
            enter-to="opacity-50"
            leave="duration-100 ease-in"
            leave-from="opacity-50"
            leave-to="opacity-0"
          >
            <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-50" />
          </TransitionChild>

          <span class="inline-block h-screen align-middle" aria-hidden="true"> &#8203; </span>

          <TransitionChild
            as="template"
            enter="duration-100 ease-out"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="duration-100 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95"
          >
            <div
              class="inline-block w-full lg:w-2/3 xl:w-1/2 px-8 md:px-12 py-12 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl"
            >
              <div class="flex justify-between">
                <DialogTitle
                  v-if="title"
                  as="h3"
                  class="text-2xl leading-6 text-gray-900 align-baseline"
                >
                  {{ title }}

                  <div v-if="subtitle" class="text-xl mt-2 font-normal font-mono">
                    {{ subtitle }}
                  </div>
                </DialogTitle>
                <div class="ml-6">
                  <BaseButton @click="closeModal" iconOnly>
                    <i-heroicons-outline-x />
                  </BaseButton>
                </div>
              </div>
              <div class="mt-8">
                <slot></slot>
              </div>
            </div>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup lang="ts">
import {
  TransitionRoot,
  TransitionChild,
  Dialog,
  DialogOverlay,
  DialogTitle,
} from "@headlessui/vue";

const modalHidden = computed(() => !props.isVisible);

//Props with defaults
const props = withDefaults(
  defineProps<{
    isVisible: boolean;
    title: string;
    subtitle?: string;
  }>(),
  {
    isVisible: false,
    title: "",
    subtitle: "",
  }
);

const emit = defineEmits<{
  (e: "close"): void;
}>();

let closeModal = () => emit("close");

function keypress(e: KeyboardEvent) {
  console.log("Popup saw keypress", e);
  if (e.key === "Escape") {
    closeModal();
  }
}
</script>
